<template>
  <div class="album">
    <div class="album-header" v-if="!loading">
      <div class="album-header-text">
        <span class="album-date">{{ albumDate }}</span>
        <b-badge variant="primary" pill>{{ currentCount }} Fotos</b-badge>
      </div>
      <b-button class="album-back" variant="outline-primary" @click="$emit('close')">
        Zurück zur Übersicht
      </b-button>
    </div>
    <div class="album-photos">
      <div id="load-indicator" v-if="loading">
        <b-icon-arrow-clockwise animation="spin" font-scale="5"/>
      </div>
      <div v-else-if="!loading && (!photos || fileIds.length === 0)" class="gallery-empty">
        <h2>In diesem Album gibt es noch keine Fotos.</h2>
      </div>
      <div v-else class="gallery-wrapper">
        <div class="photo-container" @click="$emit('lightbox', photo.fileId)"
             v-for="photo in photos" :key="photo.fileId">
          <div class="photo-hover-overlay">
            <b-icon-search font-scale="3"/>
          </div>
          <picture>
            <source :srcset="photo.jpegSrcSet()" type="image/jpeg"/>
            <source :srcset="photo.webpSrcSet()" type="image/webp"/>
            <img :src="photo.defaultSrc()" type="image/jpeg" alt="Hochzeitsfoto"/>
          </picture>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Album',
  components: {
  },

  props: {
    album: {
      type: Object,
      required: true,
    },

    photos: {
      type: Object,
      required: true,
    },

    loading: {
      type: Boolean,
    },
  },

  computed: {
    albumDate() {
      return moment(this.album.date).format('DD.MM.YYYY');
    },

    fileIds() {
      return this.photos ? Object.keys(this.photos) : [];
    },

    currentCount() {
      return this.fileIds.length;
    },
  },

  methods: {
    dateCompare(a, b) {
      if (a.getTime() < b.getTime()) {
        return -1;
      }
      if (a.getTime() > b.getTime()) {
        return 1;
      }

      return 0;
    },
  },
};
</script>

<style lang="scss">
main#gallery {
  flex: 1 0 auto;

  padding: 1.5rem;

  #load-indicator {
    display: flex;
    align-items: center;
    justify-content: center;

    line-height: 1;

    height: 70vh;
    width: 100%;

    margin: auto;

    color: rgba(0, 0, 0, 0.25);
  }

  .album {
    margin-bottom: 3rem;
    margin-left: auto;
    margin-right: auto;

    width: 100%;
    max-width: 1200px;

    &:last-child {
      margin-bottom: 0;
    }

    .album-header {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-start;

      margin-bottom: 1rem;

      div.album-header-text {
        flex: 1 0 auto;

        text-align: left;

        .album-date {
          font-size: 1.8rem;
          font-family: "Sitka Banner", serif;
        }

        .badge {
          position: relative;
          top: -3px;
          padding: 0.25rem 0.5rem;
          margin-left: 1rem;
        }
      }

      .album-back {
        flex: 0 0 auto;
        text-decoration: none !important;
      }
    }

    .gallery-empty {
      padding: 1.5rem;
      width: 100%;
      margin: auto;

      border: 1px solid black;

      h2 {
        margin: 0;

        font-family: "Sitka Banner", serif;
      }
    }

    .gallery-wrapper {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      margin: -1px;

      .photo-container {
        position: relative;

        height: 300px;

        cursor: pointer;

        margin: 1px;

        .photo-hover-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;

          z-index: 10;

          opacity: 0;
          background-color: black;
          color: white;

          transition: opacity 500ms ease;

          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          line-height: 1;
        }

        &:hover {
          .photo-hover-overlay {
            opacity: 0.25;
          }
        }

        picture, picture img {
          height: 100%;
          width: auto;
        }
      }
    }
  }
}

#lightbox-wrapper,
#lightbox-backdrop {
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
}

#lightbox-wrapper {
  z-index: 30;
  overflow: hidden;

  display: flex;
  flex-direction: column;
}

#lightbox-backdrop {
  background-color: rgba(0, 0, 0, 0.9);
}

.lightbox-header {
  display: flex;
  flex-direction: row;
  align-items: center;

  z-index: 40;

  margin: 0 1rem;

  .lightbox-title {
    padding: 1rem 0 1rem 2.75rem;

    font-weight: 500;
    font-family: "Sitka Banner", serif;
    font-size: 1.6rem;

    color: white;

    flex: 1 0 auto
  }

  .lightbox-close {
    line-height: 1;

    flex: 0 0 auto;
    padding: 0;

    color: hsl(0, 0, 50%);
    background-color: transparent;
    transition: color 500ms ease, background-color 500ms ease;

    cursor: pointer;

    border: none;
    outline: none;

    &:hover {
      color: hsl(0, 0, 75%);
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
}

.lightbox-footer {
  font-family: "Roboto", sans-serif;
  font-style: italic;
  color: white;

  padding: 1rem 0;

  z-index: 40;
}

.lightbox-main {
  width: 100%;

  flex: 1 1 auto;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;

  overflow: hidden;

  z-index: 40;

  .lightbox-content {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    justify-content: space-between;

    flex: 1 1 auto;
    height: 100%;

    z-index: 40;

    button.lightbox-control {
      flex: 1 0 auto;

      cursor: pointer;

      line-height: 1;

      background-color: transparent;
      color: hsl(0, 0, 50%);

      border: none;
      outline: none;

      display: flex;
      align-items: stretch;
      flex-direction: row;

      &:first-child {
        justify-content: flex-start;
        padding-left: 1rem;
      }

      &:last-child {
        justify-content: flex-end;
        padding-right: 1rem;
      }

      span {
        display: flex;
        flex-direction: row;
        align-items: center;

        flex: 0 0 auto;

        transition: background-color 500ms ease;
      }

      &:not(.disabled):hover > span {
        color: hsl(0, 0, 75%);
        background-color: rgba(255, 255, 255, 0.1);
      }

      &.disabled {
        color: rgba(255, 255, 255, 0.075);
        cursor: default;
      }
    }

    picture {
      height: 100%;
      width: auto;

      max-width: 80%;

      img {
        height: 100%;
        width: auto;
      }
    }

    .lightbox-glue {
      flex: 1 0 1rem;
    }
  }
}
</style>
